import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Ability } from '@casl/ability';
import { ProductNodeDto, SubstanceDTO } from '@scip/api';
import { AbilityActions, AbilitySites, ProductsService, ProductTabIdentifier, SelectedNode } from '../../../../../services';
import { ProductTypeEnum } from '../../../../../core';

@Component({
  selector: 'scip-declaration-node-editor',
  templateUrl: './declaration-node-editor.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeclarationNodeEditorComponent implements OnInit {
  @Input()
  set selectedNodeIdentifier(nodeIdentifier: string) {
    if (nodeIdentifier?.length) {
      const productOrSubstance: SelectedNode = this.productsService.getRecentProductNodeOrSubstanceForSelector(this._tabIdentifier, nodeIdentifier);
      this.product = productOrSubstance.product;
      this.substance = productOrSubstance.substance;

      this.isShow = true;
    } else {
      this.isShow = false;
    }
  }

  @Input() set productIdentifier(val: number) {
    this._tabIdentifier = `${val}`;
  }

  disableFormFields = true;
  isShow = false;
  product: ProductNodeDto;
  productType: typeof ProductTypeEnum = ProductTypeEnum;
  substance: SubstanceDTO;

  private _tabIdentifier: ProductTabIdentifier;

  constructor(private ability: Ability, private productsService: ProductsService) {}

  ngOnInit(): void {
    this.disableFormFields = !this.ability.can(AbilityActions.update, AbilitySites.product);
  }

  productChanged(product: ProductNodeDto): void {
    this.productsService.setUserChangedProductNode(this._tabIdentifier, product);
  }
}
